import { IAvailableSlot } from '@api/appointments/types';

export interface IRawVisit {
  name?: string;
  type?: string;
  md?: boolean;
  duration?: number | string;
  time?: string;
  date?: number | string;
  protocolWindow?: number | string;
  notificationsSettings?: {
    types?: { sms?: boolean; email?: boolean };
    first?: number;
    second?: number;
  };
}

export interface IVisitTemplate {
  index: number;
  name: string;
  type: string;
  md: boolean;
  duration: number;
  time: string;
  date?: number;
  protocolWindow?: number;
  notificationsSettings: {
    types: {
      sms: boolean;
      email: boolean;
    };
    first: number;
    second?: number;
  };
}

export interface IVisitSelection {
  visitIndex: number;
  selectedSlot: IAvailableSlot | null;
  selectedDate: string;
  notificationsSettings?: {
    types: {
      sms: boolean;
      email: boolean;
    };
    first: number;
    second?: number;
  };
}

export enum MultiAppointmentStep {
  PatientTrial = 0,
  VisitSelection = 1,
  SlotPicker = 2,
  NotificationSettings = 3,
  ReviewConfirm = 4,
}
